export default "__VITE_ASSET__D903RKM___"